export default "__VITE_ASSET__BAYEWcI1__"